import ReactStrapTable from 'components/reactStrapTable';
import React, { useState, useEffect } from 'react'
import { cellRendererCheck, currencyFormat, dateFormate } from 'utils/columns';
import EditIcon from "assets/icon/icon-icon-options-edit.svg";
import EditHoverIcon from "assets/icon/icon-icon-options-edit_hover.svg";
import HoverImage from 'react-hover-image/build';
import { Button } from 'reactstrap';
import HistoryIcon from "assets/icon/icon-icon-options-history.svg";
import HistoryHoverIcon from "assets/icon/icon-icon-options-history_hover.svg";
import AttachHoverIcon from "assets/icon/icon-icon-options-attachment_hover.svg";
import AttachIcon from "assets/icon/icon-icon-options-attachment.svg";
import EyeIcon from "assets/icon/icon-icon-options-view-patient.svg";
import EyeIconHover from "assets/icon/icon-icon-options-view-patient_hover.svg";
import { ModuleAccess } from 'utils/moduleaccess';
import Drawer from 'components/Drawer';
import { NumericFormat } from 'react-number-format';
//let tableDataBackup = [];

let isRole = ["GWPHA", "GWPHU"]

const DrugcatalogTable = (props) => {
  const {
    data,
    onExport,
    loading,
    totalSize,
    onPageChange,
    collapseSider,
    toggleSider,
    filters,
    accountType,
    refetch,
    onSearchColumnFilters=()=>"",
  } = props;
  //tableDataBackup = data;
  const [detailsDrawer, setDetailsDrawer] = useState(false);
  const [commentDrawer, setCommentDrawer] = useState(false);
  //const [tableData, setTableData] = useState(tableDataBackup);
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const [viewDrawer, setViewDrawer] = useState(false);
  


  // useEffect(() => {
  //   setTableData(data);
  //   tableDataBackup = data;
  // }, [data]);
  const rowData = [
    {
      "claimID": 13727987,
      "comments": 18276259,
      "filldate": "2024-11-20T10:02:02",
      "daterxnumber": "7576564545",
      "prescription": "6465453205",
      "refill": "Patient3",
      "frstname": null,
      "lastname": null,
      "dob": null,
      "prescribername": "965677885",
      "prescribernpi": "test5",
      "dispensedQuantity": 100,
      "ndc": 5,
      "drugname": "Payor3",
      "mfgname": "TEST",
      "claimsub": "TEST",
      "reason": "TEST",
      "chainpharmacy": "857907456",
      "pharmacy": "564",
      "pharmacynabp": "pharmacy",

    },
    {
      "claimID": 13727987,
      "comments": 18276259,
      "filldate": "2024-11-20T10:02:02",
      "daterxnumber": "7576564545",
      "prescription": "6465453205",
      "refill": "Patient3",
      "frstname": null,
      "lastname": null,
      "dob": null,
      "prescribername": "965677885",
      "prescribernpi": "test5",
      "dispensedQuantity": 100,
      "ndc": 5,
      "drugname": "Payor3",
      "mfgname": "TEST",
      "claimsub": "TEST",
      "reason": "TEST",
      "chainpharmacy": "857907456",
      "pharmacy": "564",
      "pharmacynabp": "pharmacy",

    },


  ]
  const renderEditButton = (rowData) => {
    // if (hasPermission("EDT")) {

    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => toggleViewDrawer(rowData)}

        title="Edit Claim"
      //hidden={rowData.claimType == 'R' || rowData.reasonDesc == "Reversal Received"}
      >
        <HoverImage src={EditIcon} hoverSrc={EditHoverIcon} alt="" />
      </Button>
    );
    // }
  };
    const { roles } = profile || {};
    var con = isRole.includes(roles);

   const { token_type, access_token, profile } =
  JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  const renderCommentsButton = (rowData) => {
    // if (hasPermission("ATH"))
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => toggleCommentDrawer(rowData)}
        title="Attachment"
      >
        <HoverImage
          key="AttachIcon"
          src={AttachIcon}
          hoverSrc={AttachHoverIcon}
          alt=""
        />
      </Button>
    );
  };
  const renderViewButton = (rowData) => {
    // if (hasPermission("VWD"))
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => toggleViewDrawer(rowData)}
      >
        <HoverImage
          key="EyeIcon"
          src={EyeIcon}
          hoverSrc={EyeIconHover}
          alt=""
        />
      </Button>
    );
  };
  const cellRenderEdit = (rowData) => {
    return (
      <div className='d-flex aligb-items-center'>
        {renderEditButton(rowData)}
        {renderCommentsButton(rowData)}


      </div>
    )
  };
   useEffect(() => {
      setHasExportPermission(ModuleAccess("DC", "EXP"));
    }, []);

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };
  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
    }
  };

  const handleFilterCancel = () => {
    refetch();
  };

  const cellEditRender = (rowdata) => {
  }
  let mainCol = [
    {
      dataField: "Options",
      text: "Options",
      // cellRenderer: (rowData) => cellRenderEdit(rowData),
      width: 100,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
    },
    {
      dataField: "wholesalerDrugCode",
      text: "Item #",
      cellRenderer: (rowData) => cellRendererCheck(rowData.wholesalerDrugCode),
      hideColFilter:true,
      sort: true,
      width: 120,
      show: true,
      inputType: "number",
      hideColFilter: false,
    },
    {
      dataField: "accountType",
      text: "Account Type",
      cellRenderer: (rowData) => cellRendererCheck(rowData.accountType),
      sort: false,
      width: 144,
      show: true,
      edit: true,
      inputType: "text",
      hideColFilter: true
    },
    {
      dataField: "chainpharmacy",
      text: "Chain Pharmacy",
      cellRenderer: (rowData) => cellRendererCheck(rowData.chainpharmacy),
      sort: false,
      width: 288,
      show: accountType == 2 ? true: false,
      inputType: "text",
      hideColFilter: true
    },
     
    {
      dataField: "coveredEntityName",
      text: "Covered Entity",
      cellRenderer: (rowData) => cellRendererCheck(rowData.coveredEntityName),
      sort: false,
      width: 288,
      show: accountType == 1 ? true: false,
      edit: true,
      inputType: "text",
      hideColFilter: true
    },
    {
      dataField: "pharmacyName",
      text: "Pharmacy",
      cellRenderer: (rowData) => cellRendererCheck(rowData.pharmacyName),
      sort: false,
      width: 288,
      show: true,
      edit: true,
      inputType: "text",
      hideColFilter: true
    },
    {
      dataField: "npi",
      text: "Pharmacy NPI",
      cellRenderer: (rowData) => cellRendererCheck(rowData.npi),
      sort: false,
      width: 144,
      show: true,
      edit: true,
      inputType: "text",
      hideColFilter:true
    },
 
    {
      dataField: "ndc",
      text: "NDC",
      cellRenderer: (rowData) => cellRendererCheck(rowData.ndc),
      sort: true,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter:false
  
    },
    {
      dataField: "drugName",
      text: "Drug Name",
      cellRenderer: (rowData) => cellRendererCheck(rowData.drugName),
      sort: false,
      width: 288,
      show: true,
      inputType: "text",
      hideColFilter:true
    },
    {
      dataField: "drugManufacturerName",
      text: "Mfg. Name ",
      cellRenderer: (rowData) => cellRendererCheck(rowData.drugManufacturerName),
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter:true
     
    },
    {
      dataField: "brandGenericFlag",
      text: "Brand or Generic",
      cellRenderer: (rowData) => cellRendererCheck(rowData.brandGenericFlag),
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter:true
    },
    {
      dataField: "drugClass",
      text: "Drug Class",
      cellRenderer: (rowData) => cellRendererCheck(rowData.drugClass),
      sort: false,
      width: 144,
      show: true,
      inputType: "text",
      edit: true,
      hideColFilter:true
    },
    {
      dataField: "packageSize",
      text: "Package Size",
      cellRenderer: (rowData) => cellRendererCheck(rowData.packageSize),
      sort: false,
      width: 144,
      show: true,
      inputType: "number",
      hideColFilter:true
     
    },
    {
      dataField: "unitOfMeasure",
      text: "UOM",
      cellRenderer: (rowData) => cellRendererCheck(rowData.unitOfMeasure),
      sort: true,
      width: 144,
      show: true,
      inputType: "text",
      hideColFilter:false
    },
    {
      dataField: "accountNumber",
      text: "Account #",
      cellRenderer: (rowData) => cellRendererCheck(rowData.accountNumber),
      sort: false,
      width: 144,
      show: true,
      edit: true,
      inputType: "text",
      hideColFilter:true
    },
    {
      dataField: "packagePrice",
      text: "Price ($)",
      cellRenderer: (rowData) => currencyFormat(rowData.packagePrice),
      sort: true,
      width: 144,
      show: true,
      edit: true,
      inputType: "number",
      hideColFilter:false
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      cellRenderer: (rowData) => dateFormate(rowData.modifiedDate),
      sort: false,
      width: 144,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter: true
    },
    {
      dataField: "modifiedBy",
      text: "Modified By",
      cellRenderer: (rowData) => cellRendererCheck(rowData.modified),
      sort: false,
      width: 144,
      show: true,
      edit: true,
      inputType: "date",
      hideColFilter:true
    },

  ];

  const toggleCommentDrawer = (rowData) => {
    setCommentDrawer((pre) => !pre);
  };
  const toggleViewDrawer = (rowData) => {
    setViewDrawer((pre) => !pre);
  };

  return (

    <div>
      <h5 className="f-16 text-primary font-weight-700">
        Drug Catalog Count ({totalSize})
      </h5>
      <hr/>
      <div
        className="table-card scroll-table position-relative border-0 rounded pt-0"
        fixed-height={rowData?.length > 0 ? "fixed-height" : "default"}
      >
        <ReactStrapTable
          id="inventory-table"
          height={550}
          fixedColumn
          width={1200}
          hasPagination
          data={data}
          columns={mainCol}
          onExport={onExport}
          filters={filters}
          totalRecords={totalSize}
           pageSize={filters.pageSize}
           currentPage={filters.currentPage}
          collapseSider={collapseSider}
          toggleSider={toggleSider}
          enabletogglesider={true}
          handleSort={onHandleSort}
          onPageChange={onHandlePageChange}
          onPageSizeChange={onPageSizeChange}
          onFilterCancel={handleFilterCancel}
          onSearchColumnFilters={handleSearchColumnFilters}
          hasExportPermission={hasExportPermission}

        />


      </div>

    </div>
  )
}

export default DrugcatalogTable